import { Helmet } from "react-helmet-async"


interface OpportunitiesMetaTagsProps {
  searchQuery?: string
}

export const OpportunitiesMetaTags = ({ searchQuery }: OpportunitiesMetaTagsProps) => {
  return (
    <Helmet>
      <title>
        {searchQuery 
          ? `${searchQuery} - CauseConnect Opportunities` 
          : 'Volunteering Opportunities - CauseConnect'}
      </title>
      <meta 
        name="description" 
        content={searchQuery 
          ? `Find ${searchQuery} volunteering opportunities on CauseConnect. Browse and connect with meaningful CSR initiatives.`
          : 'Browse volunteering opportunities on CauseConnect. Find and connect with meaningful CSR initiatives that match your interests.'
        } 
      />
      <meta name="keywords" content="CSR opportunities, corporate volunteering, social impact, community service" />
    </Helmet>
  )
}